module.exports = __webpack_public_path__ + "media/press/forbes-0460d0c2.png";